export default "__VITE_ASSET__MP6L1W_j__"